<template>
	<div v-if="game" class="game-details">
		<!-- TODO: remove import svgIcons after dev -->
		<svgIcons class="hide"></svgIcons>
		<TopSection :game="game"></TopSection>
		<PromoBanner :game="game"></PromoBanner>
		<InfoSection :game="game"></InfoSection>
	</div>
	<div v-else class="game-details"></div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import svgIcons from '@arena/toolkit/src/components/common/icon-sprite';
import TopSection from './top-section';
import PromoBanner from './promo';
import InfoSection from './info-section/index';

export default {
	name: 'GameDetails',
	components: {
		svgIcons,
		TopSection,
		PromoBanner,
		InfoSection,
	},
	data() {
		return {
			game: null,
		};
	},
	computed: {
		...mapState(['gameList', 'isIOS', 'isAndroid', 'isWindows']),
		url_game_title() {
			return this.$route.params.title;
		},
	},
	mounted() {},
	async created() {
		if (!this.url_game_title) {
			this.navToError();
			return;
		}
		this.getGameList().then(this.setGame);
	},
	methods: {
		...mapActions(['getGameList']),
		setGame() {
			const game = this.gameList.find((game) => game.name.toLowerCase() === this.url_game_title.toLowerCase());
			if (!game) {
				this.navToError();
				return;
			}
			this.game = game;
			dataLayer.push({
				event: 'Game Detail View',
				gameDetailSupported: this.isGameSupported(this.game),
				gameDetailName: this.game.name,
				gameDetailID: this.game.productID,
			});
		},
		navToError() {
			this.$router.replace({
				name: 'error',
			});
		},
		isGameSupported(game) {
			return (this.isWindows && (game.pc || game.steam)) || (this.isIOS && game.ios) || (this.isAndroid && game.android)
				? 'Supported'
				: 'Unsupported';
		},
	},
};
</script>

<style lang="less">
.details {
	.region-switcher {
		.region-switcher-container {
			position: absolute;
			z-index: 200;
			padding: 40px 30px 30px 30px;
			@media (max-width: 1024px) {
				padding-top: 42px;
			}
			width: 540px;
			@media (max-width: 1024px) {
				width: 375px;
			}
			border-radius: 4px;
			top: 89px;
			right: 60px;
			@media (max-width: 1024px) {
				top: 51px;
				right: 0px;
			}
			.close-x-container {
				.close-x {
					top: 20px;
					right: 31px;
				}
			}
			.btn-region {
				width: 235px;
				height: 50px;
				@media (max-width: 1024px) {
					width: 315px;
				}
				margin-left: 5px;
				margin-right: 0;
				&.primary {
					margin-left: 0;
					margin-right: 5px;
				}
				@media (max-width: 1024px) {
					margin-left: 0;
					margin-right: 0;
					margin-top: 5px;
					&.primary {
						margin-left: 0;
						margin-right: 0;
						margin-bottom: 5px;
					}
				}
			}
			.region-prompt {
				text-align: left;
				margin-bottom: 36px;
				@media (max-width: 1024px) {
					margin-bottom: 34px;
				}
			}
		}
	}
}

.game-details {
	height: 100%;
	min-height: 500px;
	overflow: hidden;
	padding-top: 56px;
	width: 100%;
}
</style>
